module.exports = __webpack_public_path__ + "img/crumbs_thumb.ac7bb481.jpg";